import React, { PropsWithChildren } from 'react';
import { gql } from '@yi/core';

import { BaseCarousel, BaseCarouselComposerProps, createSlickSettings } from './BaseCarousel';
import { CarouselPlaceholder } from './CarouselPlaceholder';
import { WithPlaceholder } from './types';
import { ArticleCard } from '../cards';

const defaultArticleSlickSettings = createSlickSettings({
  sm: {
    slidesToShow: 2,
    slidesToScroll: 2,
    variableWidth: true,
    dots: false,
  },
  md: {
    slidesToShow: 4,
    slidesToScroll: 3,
    variableWidth: true,
  },
  lg: {
    slidesToShow: 4,
    slidesToScroll: 3,
    dots: false,
  },
  xl: {
    slidesToShow: 5,
    slidesToScroll: 3,
    dots: false,
  },
  xxl: {
    slidesToShow: 6,
    slidesToScroll: 3,
    variableWidth: true,
    dots: false,
  },
});

type CarouselItem = gql.typesClient.Fragment_ArticleCard;
type Props = BaseCarouselComposerProps<CarouselItem>;

const defaultProps = {
  renderCard: (cardProps: { item: CarouselItem }) => <ArticleCard {...cardProps} />,
  getReactKey: (i: CarouselItem) => i.title,
};

type PlaceholderProps = Pick<Props, 'button'>;
const Placeholder: React.FC<PlaceholderProps> = ({ button }) => (
  <CarouselPlaceholder
    cardDimension={ArticleCard.dimension}
    headerDimensions={{ headerHeight: 14, headerWidth: 226 }}
    noButton={button === null}
  />
);

export const ArticleCarousel: React.FC<PropsWithChildren<Props>> &
  WithPlaceholder<PlaceholderProps> = props => {
  if (!props.items?.length) return null;
  return (
    <BaseCarousel<CarouselItem>
      slickSettings={defaultArticleSlickSettings}
      {...defaultProps}
      {...props}
    />
  );
};

ArticleCarousel.Placeholder = Placeholder;
